import React from "react"
import { useState, useEffect } from "react"
import { IconButton, Box, Popover } from "@mui/material"
import { Check as CheckIcon } from "lucide-react"
import useStyles from "./styles"
import { mCoresPrimarias } from "../../constants/coresArray"

/**
 * Componente para seleção de cores em formato de popover
 * @param {ColorPickerProps} props - Propriedades do componente
 */
const ColorPicker = ({ aoMudar, cCorAtual, aoFechar, lAberto, oElementoAncora }) => {
  const [cCorSelecionada, setCorSelecionada] = useState(cCorAtual || "#969696")
  const oClasses = useStyles()

  useEffect(() => {
    if (cCorAtual && cCorAtual !== cCorSelecionada) {
      setCorSelecionada(cCorAtual)
    }
  }, [cCorAtual])

  const aoSelecionarCor = (cCor) => {
    setCorSelecionada(cCor)
    aoMudar(cCor)
    aoFechar()
  }

  return (
    <Popover
      open={lAberto}
      onClose={aoFechar}
      elevation={0}
      anchorEl={oElementoAncora}
      anchorOrigin={{
        vertical: "bottom",
        horizontal: "center",
      }}
      transformOrigin={{
        vertical: "top",
        horizontal: "center",
      }}
      className={oClasses.popover}
    >
      <Box className={oClasses.colorPicker}>
        {mCoresPrimarias.map((cCor) => (
          <IconButton
            key={cCor}
            onClick={() => aoSelecionarCor(cCor)}
            sx={{
              padding: 0,
              width: 36,
              height: 36,
              bgcolor: cCor,
              borderRadius: "50%",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              "&:hover": { opacity: 0.8 },
            }}
          >
            {cCorSelecionada === cCor && <CheckIcon style={{ color: "#FFF" }} />}
          </IconButton>
        ))}
      </Box>
    </Popover>
  )
}

export default ColorPicker
